/* eslint-disable no-nested-ternary */
/* eslint-disable react/forbid-prop-types */
import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";
import {
  pathogenicVeryStrongColor,
  pathogenicStrongColor,
  pathogenicModerateColor,
  pathogenicSupportingColor,
  benignVeryStrongColor,
  benignStrongColor,
  benignModerateColor,
  benignSupportingColor,
  whiteColor,
  lightGray,
  weatheredStone,
} from "../../../../../common/helpers/colors";
import LinkifyBase from "../../../../../components/social/LinkifyBase";
import { ToggleButton, DropdownSelect } from "../../../../../components/atoms";
import ClickTooltip from "../../../../../components/atoms/Tooltip/ClickTooltip";

const getPillColors = (metCriteria, isChecked, color) => {
  let pillColor = color;
  const boltColor = isChecked ? color : lightGray;
  const bgColor = whiteColor;
  const bgColorChecked = whiteColor;
  let pillBorderColor = color;

  if (metCriteria && !isChecked) {
    pillBorderColor = color;
    pillColor = weatheredStone;
  }
  if (!metCriteria && !isChecked) {
    pillBorderColor = weatheredStone;
    pillColor = weatheredStone;
  }

  return {
    pillColor,
    boltColor,
    bgColor,
    bgColorChecked,
    pillBorderColor,
    boltHoverColor: color,
  };
};

class AcmgPill extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    const {
      classification,
      hasMargins,
      showExplanation,
      activeRules,
      rulesToggleState,
      onToggleHandle,
      onSelectChange,
      varsomeHost,
      key,
      shouldShowPointsReference,
    } = this.props;
    if (!classification) return null;
    const {
      name,
      strength: defaultStrength,
      met_criteria: metCriteria,
      user_explain: userExplain,
      description,
      implemented_in_thalia: isImplemented,
      acmg_triggered_strength: acmgTriggeredStrength,
      pathogenicity: pillPathogenicity,
    } = classification;

    const isRulePathogenic = pillPathogenicity === "Pathogenic";

    const strengthOptions = [
      {
        value: "Very Strong",
        label: shouldShowPointsReference
          ? isRulePathogenic
            ? "Very Strong + 8pts"
            : "Very Strong - 8pts"
          : "Very Strong",
      },
      {
        value: "Strong",
        label: shouldShowPointsReference
          ? isRulePathogenic
            ? "Strong + 4pts"
            : "Strong - 4pts"
          : "Strong",
      },
      {
        value: "Moderate",
        label: shouldShowPointsReference
          ? isRulePathogenic
            ? "Moderate + 2pts"
            : "Moderate - 2pts"
          : "Moderate",
      },
      {
        value: "Supporting",
        label: shouldShowPointsReference
          ? isRulePathogenic
            ? "Supporting + 1pt"
            : "Supporting - 1pt"
          : "Supporting",
      },
    ];
    const strengthOptionsBA1 = [
      {
        value: "Stand Alone",
        label: shouldShowPointsReference
          ? isRulePathogenic
            ? "Stand Alone + 8pts"
            : "Stand Alone - 8pts"
          : "Stand Alone",
      },
      {
        value: "Strong",
        label: shouldShowPointsReference
          ? isRulePathogenic
            ? "Strong + 4pts"
            : "Strong - 4pts"
          : "Strong",
      },
      {
        value: "Moderate",
        label: shouldShowPointsReference
          ? isRulePathogenic
            ? "Moderate + 2pts"
            : "Moderate - 2pts"
          : "Moderate",
      },
      {
        value: "Supporting",
        label: shouldShowPointsReference
          ? isRulePathogenic
            ? "Supporting + 1pt"
            : "Supporting - 1pt"
          : "Supporting",
      },
    ];
    const pathogenicColors = {
      "Stand Alone": pathogenicVeryStrongColor,
      "Very Strong": pathogenicVeryStrongColor,
      Strong: pathogenicStrongColor,
      Moderate: pathogenicModerateColor,
      Supporting: pathogenicSupportingColor,
    };

    const benighColors = {
      "Stand Alone": benignVeryStrongColor,
      "Very Strong": benignVeryStrongColor,
      Strong: benignStrongColor,
      Moderate: benignModerateColor,
      Supporting: benignSupportingColor,
    };

    const strength = acmgTriggeredStrength || defaultStrength;

    const color =
      name.charAt(0) === "P"
        ? pathogenicColors[strength]
        : benighColors[strength];

    const isChecked = rulesToggleState[name];
    const options = name === "BA1" ? strengthOptionsBA1 : strengthOptions;
    const disabledSelectedOption =
      name === "BA1" ? "Stand Alone" : strength || "Strong";
    const selectValue = {
      value: activeRules[name] || disabledSelectedOption,
      label: activeRules[name] || disabledSelectedOption,
    };

    const {
      pillColor,
      boltColor,
      bgColor,
      bgColorChecked,
      pillBorderColor,
      boltHoverColor,
    } = getPillColors(metCriteria, isChecked, color);

    return (
      <div
        key={key}
        className={`tw-flex tw-flex-col  ${
          !isChecked ? `tw-justify-center` : ""
        }`}
        style={{
          display: "flex",
          alignItems: "center",
          color: "white",
          backgroundColor: pillColor,
          width: "122px",
          height: "44px",
          padding: "0 0.7em",
          borderRadius: "30px",
          flexDirection: "column",
          justifyContent: "flex-end",
          border: `2px solid ${pillBorderColor}`,
          ...(hasMargins && { margin: "3px" }),
        }}
      >
        <div
          style={{
            width: "90px",
          }}
          className="tw-flex"
        >
          <div
            className="tw-flex tw-items-center tw-text-sm tw-font-bold"
            style={{
              color: "white",
              flex: "1",
            }}
          >
            <a
              style={{
                color: whiteColor,
                lineHeight: "0.8rem",
                fontSize: "15px",
                position: "relative",
                top: "1px",
              }}
              href={`${varsomeHost}/about/germline-implementation/#${name.toLowerCase()}`}
              target="_blank"
            >
              {name}
            </a>
          </div>

          <ToggleButton
            noPaddingAndMargin={true}
            onToggleClick={(e) => {
              onToggleHandle(classification, e.target.checked);
            }}
            isChecked={isChecked}
            colors={{ boltColor, bgColor, bgColorChecked, boltHoverColor }}
            toggleHover={true}
          />
          <div
            className="tw-ml-1.5"
            data-delay-show={500}
            data-arrow-color="#f7f6f6"
          >
            <ClickTooltip
              ContentRenderer={() => (
                <div className="tw-p-2">
                  <div>
                    <span className="tw-font-bold">Rule Name: </span>
                    {name}
                  </div>
                  <div>
                    <span className="tw-font-bold">Strength: </span>
                    {strength}
                  </div>
                  <div>
                    <span className="tw-font-bold">Definition: </span>
                    {description}
                  </div>

                  {showExplanation &&
                    userExplain &&
                    userExplain !== "undefined" && (
                      <React.Fragment>
                        <hr />
                        <div className="tw-font-bold">Explanation: </div>
                        <div className="tw-font-normal">
                          <LinkifyBase inputTxt={userExplain} />
                        </div>
                      </React.Fragment>
                    )}
                  <div className="tw-text-xs">
                    {isImplemented && (
                      <>
                        <span className="tw-font-bold">Criteria met: </span>
                        {metCriteria ? (
                          <FontAwesomeIcon
                            icon={faCheck}
                            size="lg"
                            fixedWidth={true}
                            className="tw-text-green-600"
                            tooltip="Yes"
                          />
                        ) : (
                          <FontAwesomeIcon
                            icon={faTimes}
                            size="lg"
                            fixedWidth={true}
                            className="tw-text-red-500"
                            tooltip="No"
                          />
                        )}
                        {metCriteria && !isChecked && (
                          <>
                            <span className="tw-font-bold tw-block tw-mt-0.5">
                              Manually disabled:{" "}
                              <FontAwesomeIcon
                                icon={faCheck}
                                size="lg"
                                fixedWidth={true}
                                className="tw-text-green-600"
                                tooltip="Disabled by user"
                              />
                            </span>
                          </>
                        )}

                        {!metCriteria && isChecked && (
                          <>
                            <span className="tw-font-bold tw-block tw-mt-0.5">
                              Manually overridden:{" "}
                              <FontAwesomeIcon
                                icon={faCheck}
                                size="lg"
                                fixedWidth={true}
                                className="tw-text-green-600"
                                tooltip="Manually overriden by user"
                              />
                            </span>
                          </>
                        )}
                      </>
                    )}
                  </div>

                  {!isImplemented && (
                    <React.Fragment>
                      <div className="tw-font-bold">
                        Rule not implemented
                        <FontAwesomeIcon
                          icon={faTimes}
                          size="lg"
                          fixedWidth={true}
                          className="tw-px-1 tw-text-red-500"
                        />
                      </div>
                    </React.Fragment>
                  )}
                </div>
              )}
            >
              <i
                className="fa fa-question-circle tw-cursor-pointer tw-text-white tw-opacity-70 hover:tw-opacity-100"
                style={{
                  fontFamily: __IS_COMPONENTS_PORTAL__
                    ? "Font Awesome 5 Free"
                    : "FontAwesome",
                  fontSize: "15px",
                }}
              />
            </ClickTooltip>
          </div>
        </div>
        <DropdownSelect
          menuPortalTarget={document.body}
          menuPosition="absolute"
          menuPlacement="bottom"
          styles={{
            top: "1px",
            position: "relative",
          }}
          fontSize={__IS_COMPONENTS_PORTAL__ ? "1rem" : "0.85rem"}
          className="tw-p-0"
          options={options}
          onSelectChange={(e) => onSelectChange(e, name)}
          value={selectValue}
          selectColor="transparent"
          size="94px"
          height="20px"
          isDisabled={!isChecked}
          menuItemsContainerSize="128px"
        />
      </div>
    );
  }
}

AcmgPill.propTypes = {
  key: PropTypes.string,
  varsomeHost: PropTypes.string.isRequired,
  classification: PropTypes.shape({
    pathogenicity: PropTypes.string,
    name: PropTypes.string,
    strength: PropTypes.string,
    met_criteria: PropTypes.bool,
    user_explain: PropTypes.arrayOf(PropTypes.any),
    description: PropTypes.string,
    implemented_in_thalia: PropTypes.bool,
    user_explain_failed: PropTypes.arrayOf(PropTypes.any),
    acmg_triggered_strength: PropTypes.string,
  }).isRequired,
  hasMargins: PropTypes.bool.isRequired,
  showExplanation: PropTypes.bool,
  activeRules: PropTypes.shape({}).isRequired,
  rulesToggleState: PropTypes.shape({}).isRequired,
  onToggleHandle: PropTypes.func.isRequired,
  onSelectChange: PropTypes.func.isRequired,
  shouldShowPointsReference: PropTypes.bool.isRequired,
};

AcmgPill.defaultProps = {
  showExplanation: false,
  key: "",
};

const mapStateToProps = (state) => {
  return {
    varsomeHost: state.varsomeHost,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(AcmgPill);
